import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
}

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: ""
};

export const payChargesReducer =
    (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_PAYMENT_CREATE_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.GLOBAL_PAYMENT_CREATE_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.GLOBAL_PAYMENT_CREATE_FAILURE:
      const paymentFields: string[] = [];

      if (action.payload?.err.fields.includes("amount")) {
        paymentFields.push("amountForPayment");
      }

      if (action.payload?.err.fields.includes("currency")) {
        paymentFields.push("currencyIdForPayment");
      }

      if (action.payload?.err.fields.includes("dateOfThePayment")) {
        paymentFields.push("dateOfThePayment");
      }

      if (action.payload?.err.fields.includes("firstDateOfStatementPeriod")) {
        paymentFields.push("firstDateOfStatementPeriodForPayment");
      }

      if (action.payload?.err.fields.includes("agencyBankAccount")) {
        paymentFields.push("agencyBankAccountIdForPayment");
      }

      if (action.payload?.err.fields.includes("contactId")) {
        paymentFields.push("selectedPersonForPayment");
      }

      if (action.payload?.err.fields.includes("companyId")) {
        paymentFields.push("selectedCompanyForPayment");
      }

      if (action.payload?.err.fields.includes("description")) {
        paymentFields.push("descriptionForPayment");
      }

      return {
        ...state,
        isFetching: false,
        fields: paymentFields,
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_BANK_ACCOUNT_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_PAYMENT_CREATE_CLEAR:
    case Constants.GLOBAL_BANK_ACCOUNT_CREATE_CLEAR:
    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
